import i18n from './config';
import { detectCountryCode } from '../geo/geoLocation';

// Mapping country ISO codes to our supported languages
const COUNTRY_TO_LANGUAGE = {
  // Spanish speaking countries
  ES: 'es', MX: 'es', CO: 'es', AR: 'es', PE: 'es', CL: 'es',
  VE: 'es', EC: 'es', GT: 'es', CU: 'es', BO: 'es', DO: 'es',
  HN: 'es', PY: 'es', SV: 'es', NI: 'es', CR: 'es', PA: 'es',
  UY: 'es', PR: 'es',

  // French speaking countries
  FR: 'fr', BE: 'fr', MC: 'fr', SN: 'fr', CI: 'fr', CD: 'fr',
  ML: 'fr', GN: 'fr', CM: 'fr',

  // German speaking countries
  DE: 'de', AT: 'de', CH: 'de', LI: 'de', LU: 'de',

  // Philippines
  PH: 'fil',

  // English & Default
  US: 'en', GB: 'en', CA: 'en', AU: 'en', NZ: 'en', IE: 'en',
};

/**
 * Detects user country via IP address (ideal for VPN location testing)
 * Only runs if the user hasn't already manually selected a language.
 */
export async function detectLanguageByIP() {
  if (typeof window === 'undefined') return;

  // If user already manually selected a language, respect their choice
  const manualChoice = localStorage.getItem('i18nextLng_manual');
  if (manualChoice) return;

  try {
    const countryCode = await detectCountryCode();
    const detectedLang = countryCode && COUNTRY_TO_LANGUAGE[countryCode];

    if (detectedLang && detectedLang !== i18n.language) {
      i18n.changeLanguage(detectedLang);
    }
  } catch (e) {
    // If offline or blocked by adblocker, smoothly fallback to browser locale
    console.debug('IP language detection skipped, using browser locale.');
  }
}
